import { render, staticRenderFns } from "./alert.vue?vue&type=template&id=37dcbb1c&scoped=true"
import script from "./alert.vue?vue&type=script&lang=js"
export * from "./alert.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37dcbb1c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('37dcbb1c')) {
      api.createRecord('37dcbb1c', component.options)
    } else {
      api.reload('37dcbb1c', component.options)
    }
    module.hot.accept("./alert.vue?vue&type=template&id=37dcbb1c&scoped=true", function () {
      api.rerender('37dcbb1c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dash/postCreator/components/storyTab/storyMaker/alert.vue"
export default component.exports